"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Frame = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const FrameGroup_1 = require("./FrameGroup");
const Paywall_1 = require("./Paywall");
const headerFooterCommonStyles = {
    padding: "2px 8px",
    color: "text.secondary",
    alignItems: "center",
    fontSize: "0.8em",
    height: "3em",
    display: "grid",
    placeItems: "center stretch",
    margin: 0,
};
function Frame({ ["data-testid"]: testId = null, className, icon, title, titleHelp = null, tip = "", header = null, footer = null, actions = null, maximized = false, onToggleMaximized = null, children, sx = {}, component = "div", isCollapsible: isCollapsibleProp, isPaywalled = false, }) {
    var _a;
    const frameGroupCtx = (0, FrameGroup_1.useFrameGroupCtx)();
    const [expanded, setExpanded] = (0, react_1.useState)((_a = frameGroupCtx === null || frameGroupCtx === void 0 ? void 0 : frameGroupCtx.defaultExpanded) !== null && _a !== void 0 ? _a : true);
    const toggleExpanded = () => setExpanded((e) => !e);
    const isCollapsible = (0, react_1.useMemo)(() => {
        return typeof isCollapsibleProp != "undefined"
            ? isCollapsibleProp
            : Boolean(frameGroupCtx)
                ? frameGroupCtx.count > 1
                : false;
    }, [frameGroupCtx, isCollapsibleProp]);
    const body = (0, react_1.useMemo)(() => {
        const box = ((0, jsx_runtime_1.jsxs)(material_1.Box, Object.assign({ sx: {
                gridArea: "body",
                display: "grid",
                placeItems: "stretch",
                overflow: "auto",
                position: "relative",
                pointerEvents: isPaywalled ? "none" : undefined,
            } }, { children: [children, isPaywalled ? (0, jsx_runtime_1.jsx)(Paywall_1.Paywall, {}) : null] })));
        if (isCollapsible) {
            return (0, jsx_runtime_1.jsx)(material_1.Collapse, Object.assign({ in: expanded }, { children: box }));
        }
        return box;
    }, [children, expanded, isCollapsible, isPaywalled]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ "data-testid": testId, className: `Frame ${className}`, component: component, sx: Object.assign({ border: "1px solid rgba(0,0,0,0.1)", bgcolor: "background.paper", isolation: "isolate", borderRadius: "4px", display: "grid", minHeight: 0, gridTemplateRows: "min-content min-content minmax(0px, 1fr) min-content", gridTemplateAreas: `
          "title"
          "header"
          "body"
          "footer"
        `, overflow: "hidden" }, sx) }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, Object.assign({ sx: {
                    gridArea: "title",
                    backgroundColor: "background.paper",
                    top: 0,
                    zIndex: 1,
                    display: "flex",
                    alignItems: "center",
                    padding: "4px 4px 4px 16px",
                    borderRadius: "4px 4px 0 0",
                    borderBottom: "solid 1px rgb(90% 90% 90%)",
                    height: "3.65em",
                } }, { children: [(0, jsx_runtime_1.jsxs)("label", Object.assign({ style: {
                            display: "flex",
                            alignItems: "center",
                            gap: "1ch",
                            cursor: isCollapsible ? "pointer" : undefined,
                        } }, { children: [isCollapsible ? ((0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ onClick: toggleExpanded }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.ChevronRight, { style: {
                                        rotate: expanded ? "90deg" : "0deg",
                                        transition: "rotate 0.2s",
                                    } }) }))) : null, (0, jsx_runtime_1.jsxs)(material_1.Box, Object.assign({ sx: {
                                    fontSize: "1.1em",
                                    whiteSpace: "nowrap",
                                    fontWeight: "500",
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "1ch",
                                    alignItems: "center",
                                } }, { children: [icon, (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { minWidth: frameGroupCtx === null || frameGroupCtx === void 0 ? void 0 : frameGroupCtx.titleMinWidth } }, { children: title })), (0, jsx_runtime_1.jsx)("a", { id: typeof title == "string" ? title : undefined })] })), tip ? ((0, jsx_runtime_1.jsx)(material_1.Tooltip, Object.assign({ title: tip, arrow: true }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Info, { fontSize: "inherit", sx: { color: "text.secondary" } }) }))) : null, titleHelp ? ((0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({ sx: { color: "text.secondary", fontSize: "0.9em" } }, { children: titleHelp }))) : (titleHelp)] })), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { flexGrow: 1, minWidth: "1ch" } }), (0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({ sx: { marginRight: "1ch" } }, { children: isPaywalled ? ((0, jsx_runtime_1.jsxs)(material_1.Box, Object.assign({ sx: {
                                display: "flex",
                                gap: "0.6ex",
                                alignItems: "center",
                                fontSize: "0.9em",
                                color: "text.secondary",
                            } }, { children: [(0, jsx_runtime_1.jsx)(icons_material_1.NewReleases, { sx: { color: "var(--de-color-blue)" } }), "To change these settings you must", (0, jsx_runtime_1.jsx)(material_1.Link, Object.assign({ href: "https://www.decodable.co/contact", target: "_blank", onClick: (e) => {
                                        if (e.altKey || e.ctrlKey || e.metaKey) {
                                            return;
                                        }
                                        if ("Pylon" in window && typeof window.Pylon === "function") {
                                            e.preventDefault();
                                            window.Pylon("showNewMessage", `I'm interested in upgrading my plan to gain access to the ${title} feature.`);
                                        }
                                    } }, { children: "contact support" })), " ", "and upgrade your plan."] }))) : (actions) })), onToggleMaximized ? ((0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ sx: { marginLeft: "1ch" }, onClick: onToggleMaximized }, { children: maximized ? ((0, jsx_runtime_1.jsx)(icons_material_1.FullscreenExit, { fontSize: "inherit" })) : ((0, jsx_runtime_1.jsx)(icons_material_1.Fullscreen, { fontSize: "inherit" })) }))) : null] })), header ? ((0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({ sx: Object.assign({ gridArea: "header", borderBottom: "solid 1px rgb(90%, 90%, 90%)" }, headerFooterCommonStyles) }, { children: header }))) : null, body, footer ? ((0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({ sx: Object.assign(Object.assign({ gridArea: "footer", borderTop: "solid 1px rgb(90%, 90%, 90%)" }, headerFooterCommonStyles), { height: "2em", bgcolor: "background.default", borderRadius: "0 0 4px 4px" }) }, { children: footer }))) : null] })));
}
exports.Frame = Frame;
exports.default = Frame;
